import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import deviceFrame from '../../../images/device-frame.svg';
import { DeviceFrame, DevicePreviewContainer, DevicePreviewContentContainer, StylePreviewHeader, } from '../styles';
var DevicePreview = function (_a) {
    var disableTopBar = _a.disableTopBar, children = _a.children;
    return (_jsxs(DevicePreviewContainer, { children: [_jsx(DeviceFrame, { src: deviceFrame }), !disableTopBar && _jsx(StylePreviewHeader, { children: "Styles" }), _jsx(DevicePreviewContentContainer, { children: children })] }));
};
export default DevicePreview;
